// extracted by mini-css-extract-plugin
export default {"resendCode":"Verification_resendCode__daI1-","sentCode":"Verification_sentCode__jwQLv"};